module.exports = __webpack_public_path__ + "img/icon-termoa.8fe72aff.svg";